module.exports = __webpack_public_path__ + "beab160d5090f4e921cc9834620ad30a.png";